<template>
  <div>
    <div id="cont" class="container">
      <div class="row">
        <div class="col-12">
          <b-nav
              id="nav">
            <a href="#/">
              <b-img
                  :src="logoImg"
                  alt="Emu"
                  id="logo"></b-img>
            </a>
            <a href="#/assist">
              <b-img
                  :src="assistImg"
                  alt="Assist"
                  id="assist"
              ></b-img>
            </a>
            <a href="#/assist">
              <h4 id="assist_label">智能助手</h4>
            </a>
            <div class="ml-auto" id="breadcrumb">
              <small class="bc-divider">当前位置：</small>
              <a class="bc-active">首页</a>
            </div>
          </b-nav>
        </div>
      </div>
      <div class="row">
        <div id="sidebar" class="col-md-4">
          <side-bar></side-bar>
        </div>
        <div class="col-md-8">
          <b-carousel id="banner"
                      :interval="4000"
                      controls
                      indicators
                      img-width="100%"
                      img-height="100%">
            <a href="#/article">
              <b-carousel-slide
                  text="韩国现“夺命疫苗” 36人接种后死亡，相关性未确认"
                  :img-src="banner3Img"></b-carousel-slide>
            </a>
            <a href="#/article">
              <b-carousel-slide
                  text="17岁前接种HPV疫苗患宫颈癌风险降低88%"
                  :img-src="banner2Img"></b-carousel-slide>
            </a>
          </b-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import SideBar from "@/components/SideBar";

export default {
  name: "Home",
  components: {SideBar},
  data() {
    return {
      logoImg: common.logoImgSrc,
      banner1Img: common.banner1ImgSrc,
      banner2Img: common.banner2ImgSrc,
      banner3Img: common.banner3ImgSrc,
      assistImg: common.assistImgSrc,
    }
  }
}
</script>

<style>
body {
  background: #f5f5f5 !important;
}
</style>

<style scoped src="../main.css"/>